import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../ui/button";
import { Clock, LogOut, RefreshCw } from "lucide-react";

export default function SessionWarning() {
  const { sessionWarning, extendSession, logout, SESSION_TIMEOUT_MINUTES } = useAuth();

  if (!sessionWarning) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-slate-800 border border-amber-500/50 rounded-2xl p-6 max-w-sm w-full text-center space-y-4 animate-fade-in-up">
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-500/20 flex items-center justify-center">
          <Clock className="w-8 h-8 text-amber-500 animate-pulse" />
        </div>
        
        <h3 className="text-xl font-bold text-white">
          جلستك على وشك الانتهاء
        </h3>
        
        <p className="text-slate-400 text-sm">
          ستنتهي جلستك خلال 5 دقائق بسبب عدم النشاط.
          <br />
          هل تريد الاستمرار؟
        </p>
        
        <div className="flex gap-3">
          <Button
            onClick={extendSession}
            className="flex-1 bg-emerald-600 hover:bg-emerald-700"
          >
            <RefreshCw className="w-4 h-4 me-2" />
            تمديد الجلسة
          </Button>
          <Button
            onClick={logout}
            variant="outline"
            className="flex-1 border-slate-600 text-slate-300 hover:bg-slate-700"
          >
            <LogOut className="w-4 h-4 me-2" />
            تسجيل الخروج
          </Button>
        </div>
      </div>
    </div>
  );
}
